import { render, staticRenderFns } from "./CompanySkeletonLoader.vue?vue&type=template&id=bac6c1b8&"
import script from "./CompanySkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./CompanySkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports